import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const LocationNumber = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="LocationNumber" {...rest}>
      <g clipPath="url(#clip0_8935:5675)">
        <path
          d="M8.49999 14.1001L8.29999 15.6001H11.8L12 14.1001H11L11.6 9.6001L11.8 8.1001L8.69999 9.1001L8.49999 10.6001L9.99999 10.1001L9.49999 14.1001H8.49999Z"
          fill="currentColor"
        />
        <path
          d="M17.9 21.6H22.6L21 4.9C20.9 3.8 20 3 19 3H5.7C4.6 3 3.7 3.8 3.6 4.9L2 21.6H16.9L18.5 5.1C18.5 5.1 18.5 5 18.6 5H19C19 5 19 5 19 5.1L20.4 19.6H17.9V21.6ZM15.1 19.6H4.2L5.6 5.1C5.6 5.1 5.6 5 5.7 5H16.5L15.1 19.6Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_8935:5675">
          <rect
            width="20.7"
            height="18.6"
            fill="white"
            transform="translate(2 3)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
